import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CategoryList from './category_product_list';
import CategoryDetail from './category_product_detail';

class Category extends Component {
  componentDidMount(){
  }
  render() {
    //console.log(this.context);
    var params = this.context.router.route.match.params;
    var view;
    if(params.action===undefined){
      view = <CategoryList/>;
    }else{
      if(params.id===undefined){
        view = <CategoryDetail/>;
      }else{
        view = <CategoryDetail action={params.action}/>;
      }
    }
    return (
      <div className="page-wrapper">{view}</div>
    );
  }
}

Category.contextTypes = {
  router: PropTypes.object
};

export default Category;
